import * as React from 'react';
import { AnyAction, Dispatch } from 'redux';
import { takeLatest } from 'redux-saga/effects';
import { LoginRequest as ILoginRequest } from 'stageclip-common';

import { LoginRequest } from '../api/definitions/loginRequest';
import { RefreshTokenRequest } from '../api/definitions/refreshTokenRequest';
import * as EntityNormalizers from '../api/normalizers/entityNormalizers';
import * as SessionNormalizers from '../api/normalizers/sessionNormalizers';
import { DataRequestActionTypes, InternalActionTypes } from '../constants/actionTypes';

import { FormSubmitAction } from './formActions';
import { runApiRequest } from './saga/sagaActions';

export interface LoginRequestedAction extends FormSubmitAction<ILoginRequest> {
  type: DataRequestActionTypes.LoginRequested;
}

export interface LoginSuccessAction extends AnyAction {
  type: InternalActionTypes.LoginSuccessful;
  result: EntityNormalizers.NormalizedSingleEntity<SessionNormalizers.NormalizesSessions>;
}

function createLoginSuccessfulAction(
  result: EntityNormalizers.NormalizedSingleEntity<SessionNormalizers.NormalizesSessions>,
): LoginSuccessAction {
  return {
    result,
    type: InternalActionTypes.LoginSuccessful,
  };
}

function* login(action: LoginRequestedAction) {
  const request = new LoginRequest(action.formData, action.requestingComponent, action.dispatch);
  // @ts-ignore
  yield runApiRequest(request, createLoginSuccessfulAction);
}

export function* refreshToken(userId: string, token: string, component: React.Component, dispatch: Dispatch) {
  const request = new RefreshTokenRequest(userId, token, component, dispatch);
  // @ts-ignore
  yield runApiRequest(request, createLoginSuccessfulAction);
}

export function* attemptLogin() {
  yield takeLatest(DataRequestActionTypes.LoginRequested, login);
}
